<form [formGroup]="ExamSubForm ">
    <div class="">
        <div class="">
            <div class="">
                <div class="">
                    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
                        <mat-tab label="Grade Points">
                            <div class="card-body pl-1">
                                <div class="row clearfix">
                                    <div class="col-sm-12 ">
                                        <h6 class="main-content-label f10">
                                            Grade Points
                                        </h6>
                                    </div>
                                    <div class="col-sm-12">
                                            <div>
                                                <table id="datatable" class="table table-bordered text-left">
                                                    <thead>
                                                        <tr class="bgcolor">
                                                            <th class="f600">Subject Marks / Grade
                                                            </th>
                                                            <th class="f600">Grade Points
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data" formArrayName="DefineGrid">
                                                        <tr *ngFor="let option of getDefineGridControls(); let i = index"
                                                            [formGroupName]="i">
                                                            <td>
                                                                <input class="form-control input-sm"
                                                                    formControlName="EsGrdName">
                                        
                                                            </td>
                                                            <td>
                                                                <input class="form-control input-sm"
                                                                    formControlName="EsGrdPoint">
                                                            </td>
                                                            <!-- <td>
                                                                <a class="btn-floating" title="AddNew">
                                                                    <i class="fa fa-plus" aria-hidden="true"
                                                                        (click)="addnewDefine()"></i>
                                                                </a>
                                                            </td> -->
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            
                                            <button type="button" (click)="submit()"
                                            class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base">
                                          
                                                Submit
                                            
                                        </button>
                                            <button type="button" (click)="close()"
                                                class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base">
                                               
                                                    Back
                                                
                                            </button>
                                        </div>
                                </div>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>
        </div>
    </div>
</form>